import React, { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { AppLayoutTop } from 'components/appComponents';

import { useLazyGetComingNomenclatureAdjustmentInfoQuery } from 'bus/comingNomenclatureAdjustment/services/info';
import { ComingNomenclatureAdjustmentInfoItem } from 'bus/comingNomenclatureAdjustment/types';

import { BlockAdjustmentInfo, BlockAdjustmentTable } from './components';

const ComingNomenclatureAdjustmentDetailBlock: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [getComingNomenclatureAdjustmentInfoFetch] = useLazyGetComingNomenclatureAdjustmentInfoQuery();

  const [form, setForm] = useState<ComingNomenclatureAdjustmentInfoItem>({
    comment: '',
    date: '',
    transport: '',
    sum: 0,
  });

  const getComingNomenclatureAdjustmentInfo = useCallback(async () => {
    await getComingNomenclatureAdjustmentInfoFetch({ id }).unwrap().then(setForm);
  }, [getComingNomenclatureAdjustmentInfoFetch, id]);

  useEffect(() => {
    getComingNomenclatureAdjustmentInfo();
  }, [getComingNomenclatureAdjustmentInfo]);

  return (
    <div>
      <AppLayoutTop title="Корректировка запчастей" />
      <BlockAdjustmentInfo form={form} />
      <BlockAdjustmentTable adjustmentId={id} refreshDetail={getComingNomenclatureAdjustmentInfo} />
    </div>
  );
};

export default ComingNomenclatureAdjustmentDetailBlock;
